export interface ICoriolisEnable {
    'module-Coriolis':boolean
}

export const getDefaultCoriolisEnable = ():ICoriolisEnable => {
    return {
        'module-Coriolis':true
    }
}